import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const CancelIcon = (props: SvgIconProps) => (
  <CancelOutlinedIcon {...props} fontSize="small" />
);

export default CancelIcon;
